import { call, put, takeLatest } from 'redux-saga/effects';
import TicketINCAction, { TicketINCTypes } from 'redux/actions/ticketINCAction';
import {
  getIncidentTicket,
  searchIncidentTicket,
} from 'services/ticketServices';
import BaseAction from '../actions/baseAction';

export function* getListINCTicket(action: any): any {
  try {
    const result = yield call(getIncidentTicket, action.params);
    if (result.status === 200) {
      yield put(TicketINCAction.getListINCTicketSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketINCAction.getListINCTicketFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_LIST_INC_TICKET ${error}`,
      }),
    );
  }
}

export function* getMoreListINC(action: any): any {
  try {
    const result = yield call(getIncidentTicket, action.params);
    if (result.status === 200) {
      yield put(TicketINCAction.getMoreListINCSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketINCAction.getMoreListINCFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_MORE_LIST_INC ${error}`,
      }),
    );
  }
}

export function* searchINCTicket(action: any): any {
  try {
    const result = yield call(searchIncidentTicket, action.params);
    if (result.status === 200) {
      yield put(TicketINCAction.searchINCTicketSuccess(result.data));
    }
  } catch (error) {
    yield put(TicketINCAction.searchINCTicketFail());
    yield put(
      BaseAction.errorHandling({
        message: `SEARCH_INC_TICKET ${error}`,
      }),
    );
  }
}

export function* getMoreListINCWithSearch(action: any): any {
  try {
    const result = yield call(searchIncidentTicket, action.params);
    if (result.status === 200) {
      yield put(TicketINCAction.getMoreListINCSuccessWithSearch(result.data));
    }
  } catch (error) {
    yield put(TicketINCAction.getMoreListINCWithSearchFail());
    yield put(
      BaseAction.errorHandling({
        message: `GET_MORE_LIST_INC_WITH_SEARCH ${error}`,
      }),
    );
  }
}

export const watchTicketINC = [
  takeLatest(TicketINCTypes.GET_LIST_INC_TICKET, getListINCTicket),
  takeLatest(TicketINCTypes.GET_MORE_LIST_INC, getMoreListINC),
  takeLatest(TicketINCTypes.SEARCH_INC_TICKET, searchINCTicket),
  takeLatest(
    TicketINCTypes.GET_MORE_LIST_INC_WITH_SEARCH,
    getMoreListINCWithSearch,
  ),
];
